import { createSelector } from 'reselect'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import { knownPriceBreakdownTitle } from 'checkout/constants/priceBreakdownTitles'
import { getCurrentIntl } from 'i18n/util/currentIntl'

type CruiseAmendmentState = NonNullable<App.CheckoutState['cruiseAmendment']>

export const isCruisePassengerAmendmentCheckout = (state: App.State): boolean =>
  state.checkout.cart.mode === 'cruise-amend-passengers'

/**
 * The fixed fee for amending a cabin's passengers, as served by svc-order. Anything that is not a
 * positive amount is treated as nothing to pay.
 */
export function getCruiseAmendmentFeeAmount(cruiseAmendment: CruiseAmendmentState | undefined): number {
  const amount = cruiseAmendment?.config.fee.amount ?? 0
  return amount > 0 ? amount : 0
}

export const getCruiseAmendmentBreakdownView = createSelector(
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => state.checkout.cruiseAmendment,
  (postPurchaseMode, cruiseAmendment): App.WithDataStatus<Array<App.Checkout.PriceBreakdownView>> => {
    const fee = getCruiseAmendmentFeeAmount(cruiseAmendment)
    if (postPurchaseMode !== 'cruise-amend-passengers' || !cruiseAmendment || !fee) {
      return { hasRequiredData: true, data: [] }
    }

    const intl = getCurrentIntl()
    const items: Array<App.Checkout.CruiseAmendmentBreakdownView> = [{
      itemType: 'cruise-amendment-fee',
      title: '',
      additionalInfo: [{
        text: intl.formatMessage({
          id: 'CmxISWGqtPBV2dPCPSWm',
          defaultMessage: 'Cabin {cabinPosition}',
          description: 'Cabin label under the cruise passenger amendment fee line in the checkout price breakdown',
        }, { cabinPosition: cruiseAmendment.cabinPosition }),
      }],
      additionalElements: [],
    }]

    return {
      hasRequiredData: true,
      data: [{
        title: knownPriceBreakdownTitle('cruiseAmendment'),
        additionalInfoText: [],
        items,
        price: fee,
        memberPrice: 0,
      }],
    }
  },
)
